import { render, staticRenderFns } from "./ProductList.vue?vue&type=template&id=20c3bfd0&"
import script from "./ProductList.vue?vue&type=script&lang=ts&"
export * from "./ProductList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports